import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { IntegrationCard } from '@/features/integrations/components/integration-card'
import { PageHeader } from '@/widgets/app-shell/page-header'

export const Route = createFileRoute('/_authed/configuracoes/integracoes')({
  component: IntegracoesPage,
})

/**
 * Configurações → Integrações. A tela é GENÉRICA: quais bancos aparecem e o que
 * cada um pede de credencial vem de `GET /v1/integrations/catalog` — banco novo
 * é trabalho de adapter no processor, não daqui.
 */
function IntegracoesPage() {
  const { t } = useTranslation(['nav'])

  return (
    <>
      <PageHeader title={t('nav:settings.integrations')} />
      <div className="max-w-2xl p-6">
        <IntegrationCard />
      </div>
    </>
  )
}
